// extracted by mini-css-extract-plugin
module.exports = {"main":"NotificationBanner_main__RtzOu","text":"NotificationBanner_text__GYSvQ","button":"NotificationBanner_button___3B33"};